var map = {
	"./Academic.svg": 2989,
	"./Elections.svg": 4528,
	"./Enrolment.svg": 3459,
	"./Examination.svg": 9004,
	"./Graduation.svg": 8915,
	"./Revision.svg": 6580,
	"./Teaching.svg": 3884,
	"./Vacation.svg": 4807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1177;